export { default as Tabs, type TabsProps } from './Tabs';
export { default as TabsItem, type TabsItemProps } from './TabsItem';
